export const convertTabValue = 3;
export const convertTabValueIndex = 2;
export const repaymentType = 3;
export const transferType = 1;
export const cryptoType = 0;
export const FiatType = 1;

export const TRADE_AMOUNT_TYPE = {
  total: { id: 2, name: "Total" },
  amount: { id: 1, name: "Amount" },
};

export const WALLET_TYPE = {
  margin: 2,
  spot: 1,
};

export const ADVANCED_TRADE_BUY_SELL_TABS = {
  buyFromUs: 0,
  sellToUs: 1,
};

export const TRADE_HISTORY_TABS = {
  log24: 0,
  openOrder: 1,
};

export const TRADE_SIDE = {
  Buy: {
    id: 1,
    name: "Buy",
    color: "success",
  },
  Sell: {
    id: 2,
    name: "Sell",
    color: "error",
  },
};

export const TRADE_TYPE = {
  market: {
    id: 1,
    name: "Market",
    isPrice: false,
  },
  limit: {
    id: 2,
    name: "Limit",
    isPrice: true,
  },
  stopLimit: {
    id: 3,
    name: "Stop Limit",
    isPrice: true,
  },
};

export const HELP_QUESTIONS_TRADE = {
  title: " راهنمای خرید و فروش ارزهای دیجیتال  Trade ",
  description: `
    برای  شروع ابتدا از بالای صفحه <span class="n-weight-600">Trade</span>  در سمت چپ صفحه ارز مورد نظر خود را به واحد تتر یا تومان انتخاب کنید.<br> 
    
    <span class="blue-text n-weight-500">مثال :</span> شما قصد خرید بیت کوین دارید و اکانت خود را با تومان شارژ کرده اید باید BTC/TOMAN   را انتخاب کنید 
    یا اگر قصد فروش بیت کوین در اکانت خود را دارید و میخواهید آن را به تتر تبدیل کنید باید BTC/USDT  را انتخاب کنید. <br>
    <br>
    <span class="blue-text n-weight-500">مرحله 2 :</span> شما 3 گزینه برای Trade دارید:<br> <span class="n-weight-600">Spot</span> - <span class="n-weight-600">Margin</span>- <span class="n-weight-600">Convert</span>  <br>
    <br>
    <span class="blue-text n-weight-500">• Spot   :</span> ولت اصلی شما می باشد که تمام واریز و برداشت ها از این ولت صورت می گیرد و قابلیت گرفتن مارجین یا اعتبار را ندارد ، توصیه می شود کاربرانی که به تازگی وارد بازار رمز ارز شده اند از این ولت برای Trade  استفاده کنند. <br>
    <br>
    <span class="blue-text n-weight-500">• Margin   :</span> موجودی شما در مارجین است و شما امکان Trade  کردن در مارجین ولت خود را دارید ( برای استفاده از اعتبار راهنمای مارجین را مطالعه کنید و یا با ما تماس بگیرید ) <br>
    <br>
    <span class="blue-text n-weight-500">• Convert  :</span> تبدیل ارزهای با اعشار بالا که در Spot  قابل خرید و فروش نمی باشند. شما می توانید با کارمزد بالاتر از این قابلیت استفاده کنید.<br><br> 
    <span class="blue-text n-weight-500">مرحله 3  :</span>
    در 
   این مرحله با استفاده از دکمه سبز <span class="n-buy-text n-weight-600">BUY</span>   یا دکمه قرمز رنگ <span class="n-sell-text n-weight-600">SELL</span>  انتخاب می کنید که قصد خرید یا فروش ارز انتخاب شده را دارید 
  
    و در مرحله بعد انتخاب می کنید که قصد خرید از مارکت آنی بازار را دارید یا قصد گذاشتن سفارش خرید یا فروش را دارید که به شرح ذیر برای شما توضیح می دهیم. <br>
    <br>
    <span class="blue-text n-weight-500">• Market :</span> در این گزینه شما در قیمت آنی بازار ، خرید یا فروش انجام می دهید. توجه داشته باشید که قیمت مارکت بر اساس سیاست های قیمت گذاری ساناکش تعیین می گردد و با اختلاف ناچیزی از بازارهای جهانی در پایین صفحه به شما نمایش داده می شود. مسلما در نوسان های شدید بازار، این اختلاف کمی بیشتر خواهد شد. ساناکش توسط یک سیستم هوشمند واسط شما کاربران با مارکت جهانی خواهد بود.
    توجه داشته باشید که ممکن است شرایط غیر قابل پیش بینی در سیستم بوجود آید، مثل قطع ارتباط با سرورها، عدم دسترسی به اینترنت و یا هر موردی که غیر قابل پیش بینی باشد، ساناکش هیچ تعهدی در مورد خرید و فروش ارزهای دیجیتال و یا تایید نشدن سفارشات خرید و فروش بطور مستمر و دائم را ندارد.  <br>
    
    <br>
    <span class="blue-text n-weight-500">• Limit :</span> با انتخاب این گزینه قادر خواهید بود که با توجه به میزان موجودی خود، ارز دیجیتال مورد نظر را به قیمت مشخص شده توسط شما، در پایین تر از قیمت مارکت سفارش خرید یا بالاتر از آن سفارش فروش ثبت نمایید.
    مثال: فرض کنید قیمت بیت کوین در مارکت 30،000 تتر است، شما می توانید به مقدار تتری که موجود دارید در قیمت 28،000 تتر سفارش خرید بگذارید ( موجودی در دسترسی که شما می توانید با آن خرید بیت کوین انجام دهید، در بالای دکمه Confirm    به شما نمایش داده می شود ) . اگر قصد فروش بیت کوین در بالاتر از قیمت مارکت دارید، مسلما ابتدا باید به همان میزان موجودی داشته باشید تا برای مثال بتوانید در عدد 32،000 تتر سفارش فروش بگذارید.
    تمامی سفارشات باز شما در پایین چارت قسمت Open Order نمایش داده خواهد شد شما این امکان را دارید تا با استفاده از گزینه Cancel  سفارش خود را کنسل کنید. <br>
    ‌<br>
    <span class="blue-text n-weight-500">• Stop Limit :</span> با انتخاب این گزینه قادر خواهید بود برای موجودی ارز دیجیتال خود بالاتر یا پایین تر از قیمت مارکت Stop قرار دهید. 
    مثال: قیمت بیت کوین در مارکت 30،000 تتر است، شما می توانید سفارش بگذارید که اگر قیمت بیت کوین به 28،000 تتر در مارکت رسید دیگر در بازار نباشید و از بازار خارج شوید یا برعکس اگر موجودی تتر دارید و بیت کوین به بالاتر از 32،000 تتر رسید، وارد بازار شوید تا از بازار جا نمانید. ( موجودی در دسترس شما، برای سفارش Stop در بالای دکمه Confirm نمایش داده می شود ) 
    تمامی سفارشات باز شما در پایین چارت قسمت Open Order نمایش داده خواهد شد شما این امکان را دارید تا با استفاده از گزینه Cancel  سفارش خود را کنسل کنید. 
    <br>
    <br><span class="n-weight-600 n-warning-text">توجه ! </span> تمامی سفارشات  Spot Limit & Limit   شما با احتمال بالای 90 % انجام خواهد شد که توسط سیستم هوشمند ساناکش مدیریت خواهد شد.<br>
    احتمالاتی که ممکن است سفارشات شما انجام نگیرد :
    <br>
    <br>
    • قطع ارتباط با سرورها
    <br>
    • عدم دسترسی به اینترنت
    <br>
    • نوسانات شدید در مارکت 
    <br>
    • سایر موارد غیرقابل پیش بینی
    <br>
    <br>
  
    <span class="n-weight-600 n-warning-text">توجه ! </span> ساناکش هیچ تعهد و مسئولیتی در مورد سفارشات خرید و فروش ارزهای دیجیتال بطور مستمر و دائم ندارد.  
    شایان ذکر است ما برای تمامی موارد مذکور تمهیدات متعددی اندیشیده ایم لیکن احتمال انجام نشدن سفارشات امکان پذیر است. توجه داشته باشید، ساناکش هیچ منفعتی از اینکه سفارشات شما انجام بگیرد یا خیر، ندارد. بنابراین با سیستم هوشمند ما تا 90% سفارشات شما انجام خواهد شد.
    
    در مرحله بعد دو انتخاب دارید که در زیر به شرح هر یک می پردازیم: <br>
    <br>
    <span class="blue-text n-weight-500">• Amount : </span>  به شما این امکان را خواهد داد که مقدار ارزی که قصد خرید یا فروش آن را دارید تعیین کنید. 
    <br>
    <br>
    <span class="blue-text n-weight-500">• Total:  </span>با انتخاب این گزینه می توانید، تعداد تتر یا مقدار تومانی که قصد مبادله دارید را تعیین نمایید. 
    <br>
    <span class="blue-text n-weight-600">مثال : </span> اگر موجودی شما 2 عدد اتریوم است و شما میخواهید 0.25 ETH   خود را بفروش برسانید میتوانید از گزینه Amount  استفاده کنید ، اگر قصد فروش به میزان 200 USDT   یا مثلا 2,500,000   تومان از موجودی اتریوم خود را دارید از گزینه Total   استفاده کنید.<br><br>
    
    جهت راحتی وارد نمودن مقدار مورد مبادله، شما می توانید درصدی از موجودیتان را با ابزاری که در زیر باکس در اختیار شما قرار گرفته،  انتخاب نمایید.<br>
    <br>
    <span class="blue-text n-weight-500">مرحله 4 :</span>
    در آخر با کلیک بر روی دکمه Confirm   وارد صفحه بعد خواهید شد که تمام جزئیات خرید یا فروش به طور واضح نمایش داده خواهد شد، در اینجا شما فقط چند ثانیه فرصت دارید تا قیمتی که برای شما فریز شده است را Confirm نهایی کنید.<br><br>
    <span class="blue-text n-weight-500">• History 24 : </span> ساعته مبادلات انجام گرفته، در زیر چارت نمایش داده خواهد شد. <br>
    <br>
    <span class="blue-text n-weight-500">• Trade History : </span>
    برای دیدن Trade History  یا تاریخچه مبادلات روزهای قبل روی علامت کلیک کنید.<br>
    <br>
    <span class="blue-text n-weight-500">اصطلاحات به کار رفته در صفحه ترید : </span>
    <br>
    • فروش بالاتر ازقیمت مارکت = Sell Limit <br>
    • فروش پایین تر از قیمت مارکت = Sell Stop <br>
    • خرید بالاتر از قیمت مارکت = Buy Stop <br>
    • خرید پایین تر از مارکت = Buy Limit <br>
    • خرید = Buy  <br>
    • فروش  = Sell<br>
    • مقدار  = Amount<br>
    • کل  = Total<br>
    • تایید  = Confirm<br>
    • بالاترین قیمت در 24 ساعت گذشته  = High(24h)<br>
    • پایین ترین قیمت در 24 ساعت گذشته  = Low(24h)<br>
    • تغییرات 24 ساعت گذشته  = Change(24h)<br>
    `,
};
